import {Component, computed, input, Signal} from '@angular/core';
import {CheckEvaluation, CheckSeverity, CheckUtils} from '../../data/app-data-checks';
import {groupBy, orderBy, sortBy} from 'es-toolkit';
import {DynamicComponentBase} from '../../service/ng-dynamic-components.service';

type ChecksBySeverityPair = [CheckSeverity, CheckEvaluation[]];

@Component({
    selector: 'app-tooltip-checks',
    imports: [],
    templateUrl: './tooltip-checks.component.html',
    styleUrl: './tooltip-checks.component.scss',
})
export class TooltipChecksComponent extends DynamicComponentBase {

    protected readonly CheckUtils = CheckUtils;

    readonly checks = input<CheckEvaluation[]>([]);

    protected checksBySeverity = computed(() => {
        const asObject = groupBy(this.checks(), check => check.severity);
        const asList = Object.entries(asObject) as ChecksBySeverityPair[];
        return asList.sort((a, b) => CheckUtils.compareSeverity(a[0], b[0]));
    })

    constructor() {
        super();
    }

    protected checkHeader(severity: CheckSeverity) {
        switch (severity) {
            case CheckSeverity.warning: return "Warnings";
            case CheckSeverity.error: return "Errors";
            case CheckSeverity.ok: return "Information";
            default: return "Unknown";
        }
    }
}
